import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./Question3.css";
import Hourglass from "./images/hourglass.gif";

const Question3 = ({ onAnswer, userResponse }) => {
  const question = {
    title:
      "How Many Hours per day Do You Believe The Average PhD Student Spends on Research-Related Tasks?",
    questionImage: Hourglass,
    options: [
      { label: "1–2 hours", image: "/path-to-option1-image.jpg" },
      { label: "4–6 hours", image: "/path-to-option2-image.jpg" },
      { label: "6–8 hours", image: "/path-to-option3-image.jpg" },
      { label: "More than 10 hours", image: "/path-to-option4-image.jpg" },
    ],
  };

  const handleNext = () => {
    if (!userResponse[question.title]) {
      return;
    }

    setTimeout(() => {
      onAnswer(question.title, null);
    }, 1000);
  };

  return (
    <AnimatePresence>
      <motion.div
        className="question3-container"
        initial={{ opacity: 0, x: "10%" }}
        animate={{ opacity: 1, x: 0 }} //
        exit={{ opacity: 0, x: "-100vw" }}
        transition={{ duration: 1 }}
      >
        <motion.div
          className="question3-img-container"
          initial={{ opacity: 0, x: "10%" }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: "-100vw" }}
          transition={{
            duration: 0.5,
            ease: "easeOut",
          }}
        >
          <motion.img
            className="question3-img"
            src={question.questionImage}
            alt="Question"
            initial={{ opacity: 0, x: "-50vw" }}
            animate={{ opacity: 1, x: 0 }}
            transition={{
              duration: 1,
              ease: "easeOut",
            }}
          />
        </motion.div>

        <motion.h2
          className="question3-head"
          initial={{ opacity: 0, x: "10%" }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: "-100vw" }}
          transition={{ duration: 0.5, delay: 0.3 }}
        >
          {question.title}
        </motion.h2>

        <div className="option3-container">
          {question.options.map((option, index) => (
            <motion.label
              key={index}
              className={`radio3-option ${
                userResponse[question.title] === option.label ? "checked" : ""
              }`}
              htmlFor={`option-${index}`}
              initial={{ opacity: 0, x: "10%" }}
              animate={{ opacity: 1, x: 0 }} //
              exit={{ opacity: 0, x: "-100vw" }}
              transition={{
                duration: 0.5,
                delay: 0.5,
              }}
            >
              <input
                type="radio"
                id={`option-${index}`}
                name={`question-${question.title}`}
                value={option.label}
                checked={userResponse[question.title] === option.label}
                onChange={() => onAnswer(question.title, option.label)}
              />
              <span className="radio3-label">{option.label}</span>
            </motion.label>
          ))}
        </div>

        <motion.button
          type="submit"
          initial={{ opacity: 0, x: "10%" }}
          animate={{ opacity: 1, x: 0 }} //
          exit={{ opacity: 0, x: "-100vw" }}
          transition={{ duration: 0.5, delay: 1 }}
          onClick={handleNext}
          disabled={!userResponse[question.title]}
        >
          Next Question
        </motion.button>
      </motion.div>
    </AnimatePresence>
  );
};

export default Question3;
